import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TONE = {
    default: "text-slate-200",
    positive: "text-emerald-400",
    negative: "text-rose-400",
};
export function StatCard({ label, value, sublabel, tone = "default" }) {
    return (_jsxs("div", { className: "rounded-xl border border-slate-700 bg-slate-900 p-4", children: [_jsx("p", { className: "text-[10px] font-semibold uppercase tracking-wide text-slate-500", children: label }), _jsx("p", { className: `mt-1 text-xl font-semibold ${TONE[tone] ?? TONE.default}`, children: value }), sublabel && _jsx("p", { className: "mt-1 text-xs text-slate-400", children: sublabel })] }));
}
